import React from 'react'

export default function ArrowDown({className}) {
    return (
        <svg 
        className={`w-4 h-4 ${className}`}

        aria-hidden="true" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 9-7 7-7-7" />
        </svg>
    )
}
